export default {
  'payment_method.stripe_alipay': true,
  'payment_method.ach_card': false,
  'payment_method.credit_card': true,
  'payment_method.other': {
    enabled: true,
    tabText: '其它方式',
    title: '其它付款方式',
    description: '如需银行转账、对公支付或其他线下付款方式，请发送工单至计费客服邮箱：',
    email: 'billing@cloud-clusters.com',
    actionText: '提交工单',
    department: '计费',
    responseTip: '我们将在一个工作日内与您联系，协助完成支付。感谢您的支持！'
  },
  'payment_method.paypal': false,
  'payment_method.credit': false,
  'payment_method.ali_pay': false,
  'payment_method.wechat_pay': false,

  'menu.apps': false,
  'menu.vps': true,
  'menu.dedicated': true,
  'menu.k8s': false,
  'menu.ssl': false,
  'menu.domain': false,
  'menu.gpu': true,
  'menu.market': true,
  'menu.billing.information': true,
  'menu.billing.payment': true,
  'menu.dns': true,
  'menu.affiliate': true,
  'menu.products.app': false,
  'menu.products.vps': true,
  'menu.products.gpu': true,
  'menu.products.k8s': false,
  'menu.products.dedicated': true,
  'menu.products.ssl': false,
  'menu.products.domain': false,

  'account.membership': false,
  'account.information.type.simple': true,
  'account.information.bind_phone': false,

  'billing.information.validate': true,
  'billing.account.retain': false,

  'order.information.brand_trust': false,
  'order.information.payment': false
}
